import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaMetricComponent } from '../ga-metric/ga-metric.component';
import { Observable } from 'rxjs';
import { ConfigRepository } from '../../../../shared/repositories/config.repository';

@Component({
  selector: 'app-lazy-metric-secondary',
  standalone: true,
  imports: [CommonModule, GaMetricComponent],
  templateUrl: './lazy-metric-secondary.component.html',
})
export class LazyMetricSecondaryComponent {
  googleAnalyticsCodes$: Observable<string[] | null | undefined> = inject(ConfigRepository).googleAnalyticsCodes$;
}
